import { effects } from 'redux-saga'

import handleViolations from 'internal-components/src/redux/sagas/effects/handleViolations'
import callWithHmac from 'internal-components/src/redux/sagas/effects/callWithHmac'

import {
  addErrors,
  beginWork,
  clearErrors,
  qualifyAddress,
  endWork,
} from '../../modules/signupEdit/actions'

export default function* addressLookup({ invocation }, { payload }) {
  try {
    yield effects.put.resolve(beginWork())
    yield effects.put.resolve(clearErrors())

    const result = yield effects.call(
      callWithHmac,
      invocation.addressLookupLocId,
      payload.locId,
    )

    if (
      result !== null &&
      result.locId === payload.locId
    ) {
      // Single address returned, and the LOCIDs match

      yield effects.put.resolve(qualifyAddress(result))
    }

    /* else if (result.addresses.length > 0) {
      console.log('too many results or result didnt match')
      // Multiple, need to disambiguate
    } else {
      // No address found, confirm to continue
      console.log('no address found')
    } */

    return true
  } catch (e) {
    yield effects.call(handleViolations, e, addErrors)
  } finally {
    yield effects.put.resolve(endWork())
  }

  return false
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/addressLookup.js